import Splide from '@splidejs/splide';

const heroSlider          = document.querySelectorAll('.hero-slider');
const usedListingsSlider  = document.querySelectorAll('.used-product-slider');
const productListingsSlider = document.querySelectorAll('.product-slider');
const textImageSlider     = document.querySelectorAll('.text-image-slider');
const imageSlider         = document.querySelectorAll('.image-slider');
const logoSlider          = document.querySelectorAll('.logo-slider');
const brandLogoSlider     = document.querySelectorAll('.brand-logo-slider');
const productTopSlider    = document.querySelectorAll('.product-image-slider-top');
const productBottomSlider = document.querySelectorAll('.product-image-slider-bottom');
const usedTopSlider       = document.querySelectorAll('.used-image-slider-top');
const usedBottomSlider    = document.querySelectorAll('.used-image-slider-bottom');
const shopCategorySlider  = document.querySelectorAll('.shop-category-slider');

/* Hero Slider */
if ( heroSlider.length ) {
  new Splide('.hero-slider', {
    type: 'fade',
    rewind: true,
    perPage: 1,
    arrows: false,
    autoplay: true,
    speed: 500,
    interval: 5000,
    height: '36.875rem',
    breakpoints: {
      560: {
        height: '30rem',
      },
      414: {
        height: '26rem',
      },
    },
  }).mount();
}

/* Used Product Listings Slider */
if ( usedListingsSlider.length ) {
  usedListingsSlider.forEach(function(slider) {
    new Splide(slider, {
      rewind: true,
      perPage: 4,
      perMove: 1,
      speed: 500,
      autoplay: false,
      interval: 4000,
      gap: '1.25rem',
      padding: '0.625rem',
      pagination: false,
      breakpoints: {
        1272: {
          perPage: 3,
        },
        1056: {
          perPage: 2,
          padding: '0.625rem',
        },
        640: {
          perPage: 1,
          padding: '20%',
        },
        525: {
          perPage: 1,
          padding: '10%',
        },
      },
    }).mount();
  });
}

/* Brand Listings Slider */
if ( brandLogoSlider.length ) {
  brandLogoSlider.forEach(function(slider) {
    new Splide(slider, {
      rewind: true,
      perPage: 4,
      perMove: 1,
      speed: 500,
      autoplay: false,
      interval: 4000,
      gap: '1.25rem',
      padding: '0.625rem',
      pagination: true,
      arrows: true,
      breakpoints: {
        1272: {
          perPage: 3,
        },
        1056: {
          perPage: 2,
          padding: '0.625rem',
        },
      },
    }).mount();
  });
}

/* Product Listings Slider */
if ( productListingsSlider.length ) {
  productListingsSlider.forEach(function(slider) {
    new Splide(slider, {
      rewind: true,
      perPage: 4,
      perMove: 1,
      speed: 500,
      autoplay: false,
      interval: 4000,
      gap: '1.25rem',
      padding: '0.625rem',
      pagination: true,
      arrows: true,
      breakpoints: {
        1272: {
          perPage: 3,
        },
        1056: {
          perPage: 2,
          padding: '0.625rem',
        },
      },
    }).mount();
  });
}

/* Text - Image (Alternating) Gallery Slider */
if ( textImageSlider.length ) {
  textImageSlider.forEach(function(slider) {
    new Splide(slider, {
      type: 'fade',
      speed: 500,
      rewind: true,
      pagination: false,
    }).mount();
  });
}

/* Large Image Slider */
if ( imageSlider.length ) {
  imageSlider.forEach(function(slider) {
    new Splide(slider, {
      type: 'loop',
      speed: 500,
      pagination: false,
    }).mount();
  });
}

/* Small Logo Slider */
if ( logoSlider.length ) {
  logoSlider.forEach(function(slider) {
    new Splide(slider, {
      type: 'loop',
      perPage: 6,
      perMove: 1,
      speed: 500,
      interval: 1500,
      autoplay: false,
      pagination: false,
      breakpoints: {
        1056: {
          perPage: 4,
        },
        640: {
          perPage: 3,
        },
        500: {
          perPage: 2,
        },
        414: {
          perPage: 1,
        },
      },
    }).mount();
  });
}

/* Products */
if ( productTopSlider.length ) {
  var productSliderTop = new Splide('.product-image-slider-top', {
    perPage: 1,
    perMove: 1,
    speed: 300,
    arrows: false,
    pagination: false,
  })
}

if ( productBottomSlider.length ) {
  var productSliderBottom = new Splide('.product-image-slider-bottom', {
    perPage: 5,
    perMove: 1,
    speed: 300,
    isNavigation: true,
    gap: '0.25rem',
    breakpoints: {
      1272: {
        perPage: 4,
      },
      450: {
        perPage: 3,
      },
    },
  }).mount();
}

if ( productTopSlider.length && productBottomSlider.length ) {
  productSliderTop.sync( productSliderBottom ).mount();
}

/* Used Machinery */
if ( usedTopSlider.length ) {
  var usedSliderTop = new Splide('.used-image-slider-top', {
    perPage: 1,
    perMove: 1,
    speed: 300,
    arrows: false,
    pagination: false,
  })
}

if ( usedBottomSlider.length ) {
  var usedSliderBottom = new Splide('.used-image-slider-bottom', {
    perPage: 5,
    perMove: 1,
    speed: 300,
    isNavigation: true,
    gap: '0.25rem',
    breakpoints: {
      1272: {
        perPage: 4,
      },
      450: {
        perPage: 3,
      },
    },
  }).mount();
}

if ( usedTopSlider.length && usedBottomSlider.length ) {
  usedSliderTop.sync( usedSliderBottom ).mount();
}

// Shop Category Slider
if (shopCategorySlider.length) {
  shopCategorySlider.forEach(function(slider) {
    new Splide(slider, {
      rewind: true,
      perPage: 4,
      perMove: 1,
      speed: 500,
      autoplay: false,
      interval: 4000,
      gap: '1.25rem',
      padding: '0.625rem',
      pagination: true,
      breakpoints: {
        1272: {
          perPage: 3,
        },
        1056: {
          perPage: 2,
          padding: '0.625rem',
        },
        640: {
          perPage: 2,
          padding: '1rem',
        },
        525: {
          perPage: 2,
          padding: '1rem',
        },
      },
    }).mount();
  });
}



// WEBPACK FOOTER //
// ./scripts/partials/sliders.js